import { SharedBusinessEntity } from '../shared/_config/api/shared-business-entity';
import { ApiSharedMethod } from './api-methods.shared';
import { MapRfrDeliveryData } from './rfr-delivery-data/rfr-delivery-data.map';
import { ExtRfrDeliveryDataQueryI } from './rfr-delivery-data/rfr-delivery-data.query.ext';
import { RfrDeliveryDataResponseI } from './rfr-delivery-data/rfr-delivery-data.result.int';
import { MapRfrMonSave } from './rfr-mon-save/rfr-mon-save.map';
import { RfrMonSaveI } from './rfr-mon-save/rfr-mon-save.result.int';
import { MapRfrMonStack } from './rfr-mon-stack/rfr-mon-stack.maps';
import { ExtRfrMonStackQueryI } from './rfr-mon-stack/rfr-mon-stack.query.ext';
import { RfrMonStackResponseI } from './rfr-mon-stack/rfr-mon-stack.result.int';
import { MapRfrMonStacks } from './rfr-mon-stacks/rfr-mon-stacks.maps';
import { ExtRfrMonStacksQueryI } from './rfr-mon-stacks/rfr-mon-stacks.query.ext';
import { RfrMonStacksResponseI } from './rfr-mon-stacks/rfr-mon-stacks.result.int';
import { MapRfrOrdSave } from './rfr-ord-save/rfr-ord-save.map';
import { RfrOrdSaveI } from './rfr-ord-save/rfr-ord-save.result.int';
import { MapRfrOrdSearch } from './rfr-ord-search/rfr-ord-search.map';
import { ExtRfrOrdSearchQueryI } from './rfr-ord-search/rfr-ord-search.query.ext';
import { RfrOrdSearchI } from './rfr-ord-search/rfr-ord-search.result.int';
import { MapRfrSave } from './rfr-save/rfr-save.map';
import { ExtRfrSaveQueryI } from './rfr-save/rfr-save.query.ext';
import { RfrSaveI } from './rfr-save/rfr-save.result.int';

export class ApiRfrMethod<T1, T2> extends ApiSharedMethod<T1, T2> {
    static readonly rfrDeliveryData = new ApiSharedMethod<RfrDeliveryDataResponseI, ExtRfrDeliveryDataQueryI>(
        2,
        SharedBusinessEntity.delivery,
        null,
        MapRfrDeliveryData.mapResult,
        MapRfrDeliveryData.mapQuery,
    );
    static readonly rfrSave = new ApiSharedMethod<RfrSaveI, ExtRfrSaveQueryI>(
        2,
        SharedBusinessEntity.container,
        `changeReeferSettings`,
        MapRfrSave.mapResult,
        MapRfrSave.mapQuery,
    );
    static readonly rfrMonSave = new ApiSharedMethod<RfrMonSaveI, ExtRfrOrdSearchQueryI>(
        1,
        SharedBusinessEntity.reeferTempRegistration,
        `addTemperatureRegistration`,
        MapRfrMonSave.mapResult,
        MapRfrMonSave.mapQuery,
    );
    static readonly rfrOrdSave = new ApiSharedMethod<RfrOrdSaveI, ExtRfrOrdSearchQueryI>(
        1,
        SharedBusinessEntity.reeferOrder,
        `dpCommitReeferOrder`,
        MapRfrOrdSave.mapResult,
        MapRfrOrdSave.mapQuery,
    );
    static readonly rfrOrdSearch = new ApiSharedMethod<RfrOrdSearchI, ExtRfrOrdSearchQueryI>(
        1,
        SharedBusinessEntity.reeferOrder,
        null,
        MapRfrOrdSearch.mapResult,
        MapRfrOrdSearch.mapQuery,
    );
    static readonly rfrMonStacks = new ApiSharedMethod<RfrMonStacksResponseI, ExtRfrMonStacksQueryI>(
        1,
        SharedBusinessEntity.reeferTempRegistration,
        `getStacks`,
        MapRfrMonStacks.mapResult,
        MapRfrMonStacks.mapQuery,
    );
    static readonly rfrMonStack = new ApiSharedMethod<RfrMonStackResponseI, ExtRfrMonStackQueryI>(
        1,
        SharedBusinessEntity.reeferTempRegistration,
        null,
        MapRfrMonStack.mapResult,
        MapRfrMonStack.mapQuery,
    );
}
